// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"7418":"settings-apps-view","8351":"settings-users"}[chunkId] || chunkId) + "-" + chunkId + ".js?v=" + {"923":"2686613ba9d88601b889","7418":"3ff7049aa410ca141fe6","8321":"1e9a8023ef8296a459a5","8351":"1ab04a86eb8344bbcce2"}[chunkId] + "";
};